export default __webpack_public_path__ + "static/media/crossBlack.aafc0aee.svg";